import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Container, Paragraph } from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";
import { formatDate } from "shared/utils";

import styles from "./LayoutWidget086.module.scss";

export const LayoutWidget086 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId(
    "l086",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );
  const { articles } = useCollectedData(instanceId, [
    { name: "articles", defaultValue: [] },
  ]);

  const { locale } = useRouter();

  const [article] = articles;

  const articleDate = useMemo(() => {
    return formatDate(article?.date, locale);
  }, [article?.date, locale]);

  if (articles.length === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.tags}>
            {article.articleCategories?.map(({ id, title }) => (
              <Paragraph
                color="dark"
                key={id}
                appearance="smaller"
                className={styles.tag}
                uppercase
              >
                {title}
              </Paragraph>
            ))}
          </div>
          <Paragraph color="grey" className={styles.date} uppercase>
            {articleDate}
          </Paragraph>
        </div>
      </Container>
    </div>
  );
};

export default LayoutWidget086;
